import React, {createRef} from 'react'
import {findDOMNode} from "react-dom"
import HintPopover from "../../../../core/gd-ui/hint-popover/hint-popover"
import Popover from "../../../../core/gd-components/gd-popover/popover-v2"
import PopoverPosition from "../../../../core/gd-components/gd-popover/popover-position"
import {PopoverAttachmentType} from "../../../../core/gd-components/gd-popover/@const"
import MoreMenuStandardOption, {MoreButtonOptionType} from "./standard-option"
import MoreMenuCustomOption from "./custom-option"
import ExportToPdfOption from "./components/export-pdf"
import ControlButtonStandard, {ControlButtonType} from "../../../../core/gd-components/buttons/control-button/control-button-standard"

type Props = {
    className?          : string

    options             : any[]

    onTogglePopover?    : {(value:boolean):void}
}

type State = {
    showPopover : boolean
}

export enum AppControlMoreOptions {

    SEPARATOR   = 'separator',
    EXPORT_PDF  = 'export-pdf',
    // EXPORT_CSV  = 'export-csv',
    // EXPORT_PNG  = 'export-png',
    // PRINT       = 'print',

}


export default class AppControlMore extends React.Component<Props,State> {

    private hintPopoverRef: React.RefObject<any> = createRef()

    state = {
        showPopover: false
    }

    showPopover = () => {
        if (!this.state.showPopover) {
            this.setState({
                showPopover: true
            }, ()=>{
                this.hintPopoverRef.current.hide()
                this.props.onTogglePopover && this.props.onTogglePopover(this.state.showPopover)
            })
        }
    }
    hidePopover = () => {
        if (this.state.showPopover) {
            this.setState({
                showPopover: false
            }, ()=>{
                this.props.onTogglePopover && this.props.onTogglePopover(this.state.showPopover)
            })
        }
    }

    renderPopover() {
        const onClick = (menuOption:any) => {
            this.hidePopover();
            menuOption.onClick();
        }

        const popoverPosition = new PopoverPosition({
            attachment      : "top right",
            targetAttachment: "bottom right",
            attachmentType  : PopoverAttachmentType.HORIZONTAL,
        })

        return (
            <Popover
                popoverClass    = "gd-view-more-popover"
                getTargetFunc   = {()=>findDOMNode(this)}
                position        = {popoverPosition}
                onClickOutside  = {()=>{this.hidePopover()}}
            >

                <div className="ui5-popover-menu min-w-200">
                    {this.props.options.map((menuOption, key)=>{

                        if (menuOption === AppControlMoreOptions.SEPARATOR) {
                            return (
                                <div key        = {key}
                                     className  = "separator"
                                />
                            )
                        }

                        if (
                            menuOption === 'export-pdf'
                            || menuOption === MoreButtonOptionType.EXPORT_PDF
                            || menuOption.type === MoreButtonOptionType.EXPORT_PDF
                        ) {
                            return (
                                <ExportToPdfOption
                                    key         = {key}
                                    hideIcon    = {false}
                                    hidePopover = {this.hidePopover}
                                    onClick     = {menuOption.onClick}
                                />
                            )
                        }

                        if (menuOption.type) {
                            return (
                                <MoreMenuStandardOption
                                    key     = {key}
                                    option  = {menuOption}
                                    onClick = {onClick}
                                />
                            )
                        }

                        return (
                            <MoreMenuCustomOption
                                key     = {key}
                                option  = {menuOption}
                                onClick = {onClick}
                            />
                        )
                    })}
                </div>
            </Popover>
        )
    }

    render() {
        const classes = Classes(this.props.className, {
            "show-popover": this.state.showPopover
        })

        return (
            <ControlButtonStandard
                className   = {classes}
                type        = {ControlButtonType.MORE}
                onClick     = {this.showPopover}
            >
                {this.state.showPopover &&
                    this.renderPopover()
                }
                <HintPopover
                    ref             = {this.hintPopoverRef}
                    hint            = "More options"
                    checkShowHint   = {()=>!this.state.showPopover}
                />
            </ControlButtonStandard>
        )
    }
}
